import React from "react";
import { Redirect, Link } from "react-router-dom";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import {
  getRecibos,
  publicarLote,
  aceptarRRHHLote,
  aceptarRLLote,
  enviarLoteMtess,
  getEnviarNotificacion,
} from "./RecibosService";
import "../../styles/Empresa.css";
import Pin from "../recibos/Pin";
import {
  verificarRol,
  firmaRRHH,
  firmaRL,
  URL,
  gestorEmpresa,
} from "../../constans/constants";
import {
  Modal,
  ModalBody,
  Container,
  Row,
  Col,
  Button,
  Spinner,
} from "react-bootstrap";
import SeleccionPca from "../pca/SeleccionPca";
import LoginPsa from "../pca/LoginPsa";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { obtenerLote } from "../lotes/LoteService";
import arrowBack from "../../styles/icons/arrow_back.svg";
import pdfIcon from "../../styles/icons/pdf.svg";
import ExclamacionIcon from "../../styles/icons/exclamation-circle.svg";
import xCircle from "../../styles/icons/x-circle.svg";
import checkCircle from "../../styles/icons/check-circle.svg";
import search from "../../styles/icons/search.svg";

class Recibos extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: "Ingrese Pin de Firma",
      dialogType: "add",
      submitText: "Guardar",
      disabledInput: false,
      selectedRecibo: {
        recibo: "",
        fechaCarga: "",
        empleado: "",
        estado: "",
        estadoMTESS: false,
      },
      idLote: "",
      fechaImportacionLote: "",
      descripcionLote: "",
      formatoDocumentoLote: "",
      cantidadDocumentoLote: "",
      firmaLote: null,
      numeroLote: "",
      tipoFirma: "",
      redirect: false,

      openMsgVentana: false,
      openSpinner: false,
      msgVentana: "",
      error: false,

      dialogIsOpen: false,
      dialogIsOpenVerDatos: false,
      dialogPinOpen: localStorage.getItem("tokenIscert") != null ? true : false,
      dialogAceptLote: false,
      open: false,

      openPantallaCarga: false,
      msjPantallaCarga: null,

      dialogEnvioNotificacion: false,

      dialogEnvioMtess: false,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      severityFlash: "",
      openSeleccionPca: false,
      openLoginPSA: false,
      recibos: [],
      page: 0,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      search: "",
      loading: true,
    };
    localStorage.removeItem("redirectURLFirma");
    let pantallaAnterior = null;
    const datosPsa = null;
    const psaActivos = null;
    this.tableRef = React.createRef();
    this.setPantallaAnterior();
  }

  componentDidMount() {
    obtenerLote(this.props.match.params.idLote).then((res) => {
      this.setState({
        idLote: res.datos.loteRecibos.id,
        fechaImportacionLote: res.datos.loteRecibos.fechaCarga,
        descripcionLote: res.datos.loteRecibos.descripcion,
        formatoDocumentoLote:
          res.datos.loteRecibos.tipoDocumento.formato.extension,
        cantidadDocumentoLote: res.datos.loteRecibos.recibidos,
        numeroLote: res.datos.loteRecibos.numero,
        firmaLote: res.datos.loteRecibos.tipoDocumento.firmaEmpresa,
      });

      this.psaActivos = res.datos.psaActivos;
      /*
      if (res.datos.loteRecibos.tipoDocumento.firmaEmpleado.codigo == "03" || res.datos.loteRecibos.tipoDocumento.firmaEmpleado.codigo == "04") {
        this.setState({ firmaLote: false })
      } else {
        this.setState({ firmaLote: true })
      }
*/
    });
    this.fetchRecibos(0, this.state.pageSize, "");
  }
  handleDialog = (value) => {
    this.setState({
      dialogIsOpen: value,
    });
  };

  setPantallaAnterior = () => {
    localStorage.setItem("urlAnterior", window.location.href);
    this.pantallaAnterior = localStorage
      .getItem("urlRaiz")
      .substring(localStorage.getItem("urlRaiz").indexOf("#"));
  };

  handleClosePsa = () => {
    this.setState({ openSeleccionPca: false });
  };

  /*
  handleSeleccionPca = (value, data) => {
    this.datosPsa = data;
    this.setState({
      openSeleccionPca: value,
      openLoginPSA: data != null ? true : false
    });
  }
*/

  handleDialogEnvioMtess = (value) => {
    this.setState({
      dialogEnvioMtess: value,
    });
  };

  handleDialogAceptLote = (value) => {
    this.setState({
      dialogAceptLote: value,
    });
  };

  handleMsgVentana = (value) => {
    this.setState({ openMsgVentana: value, redirect: true });
  };

  handleLoginPSA = (value, data) => {
    if (data != null) {
      if (data.error) {
        this.setState({
          openLoginPSA: false,
          openMsgVentana: true,
          error: true,
          msgVentana: data.mensaje,
        });
      } else {
        localStorage.setItem("tokenIscert", data.datos.access_token);
        localStorage.setItem("codigoClienteFirma", this.datosPsa.id);
        localStorage.setItem("proveedorFirma", this.datosPsa.codigoCliente);
        this.setState({
          openLoginPSA: false,
          openMsgVentana: true,
          error: false,
          msgVentana: "Autenticado con exito",
        });
      }
    } else {
      this.setState({
        openLoginPSA: value,
      });
    }
  };

  handleDialogPin = (open, data, firma) => {
    if (localStorage.getItem("tokenIscert") != null) {
      this.setState({ dialogPinOpen: open });
      if (data != null) {
        this.setState({
          msgVentana: data.mensaje,
          openMsgVentana: true,
          error: data.error,
          tipoFirma: firma,
          redirect: false,
        });
      }
      localStorage.removeItem("tokenIscert");
      localStorage.removeItem("codigoClienteFirma");
      localStorage.removeItem("proveedorFirma");
    } else {
      this.setState({ openSeleccionPca: true });
    }
  };

  handleClose = (value) => {
    this.setState({
      open: value,
    });
  };

  enviarNotificacion = () => {
    this.setState({
      openPantallaCarga: true,
      msjPantallaCarga: "Enviando notificacion",
      dialogEnvioNotificacion: false,
    });
    var idLote = this.state.idLote;
    getEnviarNotificacion(idLote).then((res) => {
      this.setState({ openPantallaCarga: false });
      this.setState({
        msgVentana: res.mensaje,
        openMsgVentana: true,
        error: res.error,
      });
    });
  };

  descargarLote = () => {
    window.location.href = URL + "lote/descargar/" + this.state.idLote;
  };

  enviarLoteMtess = () => {
    const cookies = new Cookies();
    var idLote = this.state.idLote;
    var username = cookies.get("username");
    enviarLoteMtess(idLote, username).then((res) => {
      this.setState({ msgVentana: res.mensaje, openMsgVentana: true });
      this.handleDialogEnvioMtess(false);
    });
  };

  visualizarBotones = () => {
    if (
      this.props.match.params.estado == "nuevo" &&
      verificarRol(this.props.roles, firmaRRHH)
    ) {
      return this.state.firmaLote ? (
        <a
          className="btn btn-primary"
          style={{ backgroundColor: "#00DAF7" }}
          onClick={this.handleDialogPin}
        >
          Firmar
        </a>
      ) : (
        <a
          className="btn btn-primary"
          style={{ backgroundColor: "#00DAF7" }}
          onClick={this.handleDialogAceptLote}
        >
          Aceptar Lote
        </a>
      );
    }
    if (
      this.props.match.params.estado == "firmado" &&
      verificarRol(this.props.roles, firmaRL)
    ) {
      return this.state.firmaLote ? (
        <a
          className="btn btn-primary"
          style={{ backgroundColor: "#00DAF7" }}
          onClick={this.handleDialogPin}
        >
          Firmar
        </a>
      ) : (
        <a
          className="btn btn-primary"
          style={{ backgroundColor: "#00DAF7" }}
          onClick={this.handleDialogAceptLote}
        >
          Aceptar Lote
        </a>
      );
    }
    if (this.props.match.params.estado == "publicar") {
      return (
        <Button variant="info" onClick={this.handleClose}>
          Publicar lote
        </Button>
      );
    }
    if (
      this.props.match.params.estado == "publicado" &&
      verificarRol(this.props.roles, gestorEmpresa)
    ) {
      return (
        <Button
          onClick={() => this.setState({ dialogEnvioNotificacion: true })}
          variant="info"
          color="primary"
          type="Button"
        >
          Enviar recordatorio
        </Button>
      );
    }
    if (this.props.match.params.estado == "cerrado") {
      return (
        <Button
          variant="info"
          onClick={() => this.handleDialogEnvioMtess(true)}
        >
          Enviar a MTESS
        </Button>
      );
    }
  };

  publicarLote = () => {
    this.setState({ openPantallaCarga: true, open: false });
    publicarLote(this.state.idLote).then((response) => {
      this.setState({
        msgVentana: response.mensaje,
        openMsgVentana: true,
        isPublicado: true,
      });
    });
  };

  aceptarRRHH = () => {
    this.setState({ openPantallaCarga: true });
    aceptarRRHHLote(this.state.idLote).then((response) => {
      this.setState({
        dialogAceptLote: false,
        msgVentana: response.mensaje,
        openMsgVentana: true,
        tipoFirma: "RRHH",
        openPantallaCarga: false,
      });
    });
  };

  aceptarRL = () => {
    this.setState({ openPantallaCarga: true });
    aceptarRLLote(this.state.idLote).then((response) => {
      this.setState({
        dialogAceptLote: false,
        msgVentana: response.mensaje,
        openMsgVentana: true,
        tipoFirma: "RL",
        openPantallaCarga: false,
      });
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };

  validarMtess = () => {
    if (this.props.match.params.estado == "cerrado") return true;
    else return false;
  };

  handlePageSizeChange(event) {
    const pageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize, page: 0 }, () => {
      this.fetchRecibos();
    });
  }

  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(newPage, this.state.pageSize, "");
      });
    }
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchRecibos(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchRecibos(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">1</a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">{i + 1}</a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">{totalPages}</a>
          </li>
        );
      }
    }

    return pages;
  }

  fetchRecibos(page, pageSize, search) {
    this.setState({ loading: true });
    this.props
      .getRecibos(page, pageSize, search, this.props.match.params.idLote)
      .then(() => {
        this.setState({
          recibos: this.props.recibosData.recibos,
          page: this.props.recibosData.page,
          totalCount: this.props.recibosData.totalCount,
          totalPages: Math.ceil(this.props.recibosData.totalCount / pageSize),
          loading: false,
        });
      });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchRecibos(0, this.state.pageSize, this.state.search);
    });
  };

  render() {
    if (this.state.tipoFirma == "RRHH" && this.state.redirect) {
      return <Redirect to={"/lote/nuevos"} />;
    } else if (this.state.tipoFirma == "RL" && this.state.redirect) {
      return <Redirect to={"/lote/firmados"} />;
    } else if (this.state.isPublicado && this.state.redirect) {
      return <Redirect to={"/lote/publicar"} />;
    } else {
      return (
        <div>
          <div className="dashboardContent">
            <div className="container-fluid">
              <PantallaCarga
                open={this.state.openPantallaCarga}
                mensaje={this.state.msjPantallaCarga}
              />
              <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.dialogEnvioMtess}
                backdrop="static"
                keyboard="false"
              >
                <Container>
                  <Modal.Body>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <img
                          src={ExclamacionIcon}
                          style={{ margin: "40px" }}
                        ></img>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <p>
                          <strong>
                            ¿Está seguro que desea enviar este lote a MTESS?
                          </strong>
                        </p>
                      </Col>
                    </Row>
                    <Row style={{ background: "#EDF2F9", padding: "5px" }}>
                      <Col>
                        <p>
                          <strong>Lote: </strong>
                          {this.state.idLote} |{" "}
                          {this.state.fechaImportacionLote}
                        </p>
                        <p>
                          <strong>Descripcion:</strong>{" "}
                          {this.state.descripcionLote}
                        </p>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={() => this.handleDialogEnvioMtess(false)}
                      variant="ligth"
                    >
                      Cancelar
                    </Button>
                    <Button
                      onClick={this.enviarLoteMtess}
                      variant="primary"
                      autoFocus
                    >
                      Enviar
                    </Button>
                  </Modal.Footer>
                </Container>
              </Modal>
              <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.dialogAceptLote}
                backdrop="static"
                keyboard="false"
              >
                <Container>
                  <Modal.Body>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <img
                          src={ExclamacionIcon}
                          style={{ margin: "40px" }}
                        ></img>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <p>
                          <strong>
                            ¿Está seguro que desea aceptar el Lote?
                          </strong>
                        </p>
                      </Col>
                    </Row>
                    <Row style={{ background: "#EDF2F9", padding: "5px" }}>
                      <Col>
                        <p>
                          <strong>Lote: </strong>
                          {this.state.idLote} |{" "}
                          {this.state.fechaImportacionLote}
                        </p>
                        <p>
                          <strong>Descripcion:</strong>{" "}
                          {this.state.descripcionLote}
                        </p>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={() => this.handleDialogAceptLote(false)}
                      variant="ligth"
                    >
                      Cancelar
                    </Button>
                    <Button
                      onClick={
                        this.props.match.params.estado == "firmado"
                          ? this.aceptarRL
                          : this.aceptarRRHH
                      }
                      variant="primary"
                      autoFocus
                    >
                      Aceptar
                    </Button>
                  </Modal.Footer>
                </Container>
              </Modal>

              <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.dialogEnvioNotificacion}
                backdrop="static"
                keyboard="false"
              >
                <Modal.Body>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <img
                        src={ExclamacionIcon}
                        style={{ margin: "40px" }}
                      ></img>
                    </Col>
                  </Row>
                  <Row className="justify-content-center">
                    <Col className="text-center text-md-right">
                      <p>
                        Se enviará una notificacion por correo electronico al
                        colaborador asignado a este lote. ¿Esta seguro?
                      </p>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    onClick={() =>
                      this.setState({ dialogEnvioNotificacion: false })
                    }
                    variant="ligth"
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={() => this.enviarNotificacion()}
                    variant="primary"
                    autoFocus
                  >
                    Ok
                  </Button>
                </Modal.Footer>
              </Modal>

              <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.openMsgVentana}
                backdrop="static"
                keyboard="false"
              >
                <Container>
                  <Modal.Body>
                    {
                      <div>
                        <Row className="justify-content-center">
                          <Col className="text-center text-md-right">
                            {this.state.error ? (
                              <img
                                src={xCircle}
                                style={{ margin: "40px" }}
                              ></img>
                            ) : (
                              <img
                                src={checkCircle}
                                style={{ margin: "40px" }}
                              ></img>
                            )}
                          </Col>
                        </Row>
                        <Row className="justify-content-center">
                          <Col className="text-center text-md-right">
                            <p>
                              <strong>{this.state.msgVentana}</strong>
                            </p>
                          </Col>
                        </Row>
                      </div>
                    }
                    <Modal.Footer>
                      <Button
                        variant="primary"
                        onClick={() => this.handleMsgVentana(false)}
                      >
                        Aceptar
                      </Button>
                    </Modal.Footer>
                  </Modal.Body>
                </Container>
              </Modal>

              <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.open}
                hide={this.state.handleClose}
                backdrop="static"
                keyboard="false"
              >
                <Container>
                  <Modal.Body>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <img
                          src={ExclamacionIcon}
                          style={{ margin: "40px" }}
                        ></img>
                      </Col>
                    </Row>
                    <Row className="justify-content-center">
                      <Col className="text-center text-md-right">
                        <p>
                          <strong>
                            ¿Estas Seguro que desea publicar el lote?
                          </strong>
                        </p>
                      </Col>
                    </Row>
                    <Row style={{ background: "#EDF2F9", padding: "5px" }}>
                      <Col>
                        <p>
                          <strong>Lote: </strong>
                          {this.state.numeroLote} |{" "}
                          {this.state.fechaImportacionLote}
                        </p>
                        <p>
                          <strong>Descripcion:</strong>{" "}
                          {this.state.descripcionLote}
                        </p>
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={() => this.handleClose(false)}
                      variant="ligth"
                    >
                      Cancelar
                    </Button>
                    <Button
                      onClick={this.publicarLote}
                      variant="primary"
                      autoFocus
                    >
                      Publicar lote
                    </Button>
                  </Modal.Footer>
                </Container>
              </Modal>

              <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.dialogPinOpen}
                onHide={this.handleDialogPin}
                backdrop="static"
                keyboard="false"
              >
                <Pin
                  estado={this.props.match.params.estado}
                  //idLote={this.state.idLote}
                  numeroLote={this.state.numeroLote}
                  idLote={this.props.match.params.idLote}
                  formatoDocumento={this.state.formatoDocumentoLote}
                  fechaImportacionLote={this.state.fechaImportacionLote}
                  descripcionLote={this.state.descripcionLote}
                  cantidadDocumentoLote={this.state.cantidadDocumentoLote}
                  type={this.state.dialogType}
                  submitText={this.state.submitText}
                  disabledInput={this.state.disabledInput}
                  handleClose={this.handleDialogPin}
                  dialogTitle={
                    this.state.tipoFirma == "RRHH"
                      ? "Firma RRHH"
                      : "Firma representante legal"
                  }
                />
              </Modal>
              <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.openSeleccionPca}
                onHide={this.handleClosePsa}
                backdrop="static"
                keyboard="false"
              >
                <SeleccionPca
                  handleClose={this.handleClosePsa}
                  url={window.location.href}
                  listaPsa={this.psaActivos}
                />
              </Modal>

              <Modal
                aria-labelledby="contained-modal-title-vcenter"
                show={this.state.openLoginPSA}
                onHide={() => this.handleLoginPSA(false, null)}
                backdrop="static"
                keyboard="false"
              >
                <LoginPsa
                  handleClose={this.handleLoginPSA}
                  data={this.datosPsa}
                />
              </Modal>

              <div className="sectionHeader" style={{ paddingBottom: "20px" }}>
                <div className="actionTitle">
                  <a type="button" style={{ paddingTop: "7px" }}>
                    <img
                      src={arrowBack}
                      onClick={() =>
                        (window.location.href = this.pantallaAnterior)
                      }
                    />
                  </a>
                  <h1 className="pageTitle">
                    {" "}
                    Lote de Recibos #{this.state.numeroLote}
                  </h1>
                </div>
                <div className="actions">
                  {this.state.firmaLote != null && this.visualizarBotones()}
                  <Button variant="primary" onClick={this.descargarLote}>
                    {" "}
                    Descargar Lote{" "}
                  </Button>
                </div>
              </div>
              <div className="contentBuscador card">
                <form className="searchForm">
                  <div className="input-group input-group-lg">
                    <span
                      className="input-group-text border-0"
                      id="basic-addon2"
                    >
                      <img src={search} />
                    </span>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Buscar.."
                      aria-label="Search"
                      aria-describedby="basic-addon2"
                      value={this.state.search}
                      onChange={this.handleSearchChange}
                    />
                  </div>
                </form>
              </div>
              <div className="contentPage card" style={{ padding: "0px" }}>
                {this.state.loading ? (
                  // Muestra el spinner mientras loading sea true
                  <div className="d-flex justify-content-center p-5">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </Spinner>
                  </div>
                ) : (
                  <div>
                    <div className="table-responsive">
                      <table className="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th scope="col">Recibo</th>
                            <th scope="col">Fecha de Carga</th>
                            <th scope="col">Colaborador</th>
                            <th scope="col">Estado</th>
                            <th scope="col">Estado MTESS</th>
                            <th scope="col">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.recibosData.recibos.map(
                            (recibo, index) => (
                              <tr key={index}>
                                <th scope="row">{recibo.recibo}</th>
                                <td>{recibo.fechaCarga}</td>
                                <td>{recibo.empleado}</td>
                                <td>{recibo.estado}</td>
                                <td>{recibo.estadoMTESS ? "Sí" : "No"}</td>
                                <td>
                                  <div className="table-actions">
                                    <Link
                                      to={{
                                        pathname:
                                          "/recibo/" +
                                          recibo.recibo +
                                          "/lote/" +
                                          recibo.idLote +
                                          "/ver",
                                      }}
                                    >
                                      <a class="btn btn-secondary btn-md btn-floating">
                                        <img src={pdfIcon} />
                                      </a>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div id="paginador">
                      <label>
                        Mostrar
                        <select
                          className="form-control custom-select"
                          id="maxRows"
                          name="state"
                          value={this.state.pageSize}
                          onChange={this.handlePageSizeChange}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="20">20</option>
                          <option value="50">50</option>
                        </select>
                        resultados.
                      </label>
                      <ul className="pagination mb-0">
                        <li
                          className={`page-item ${
                            this.state.page === 0 ? "disabled" : ""
                          }`}
                          onClick={() =>
                            this.handlePageChange(this.state.page - 1)
                          }
                        >
                          <a className="page-link" type="Button">
                            <span className="material-icons">chevron_left</span>
                          </a>
                        </li>
                        {this.renderPageNumbers()}
                        <li
                          className={`page-item ${
                            this.state.page === this.state.totalPages - 1
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() =>
                            this.handlePageChange(this.state.page + 1)
                          }
                        >
                          <a className="page-link" type="Button">
                            <span className="material-icons">
                              chevron_right
                            </span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapDispatchToProps = (dispatch) => ({
  getRecibos: (page, size, search, idLote) =>
    dispatch(getRecibos(page, size, search, idLote)),
});

const mapStateToProps = (state) => ({
  recibosData: state.recibosData,
  roles: state.rolesData,
  firmaRRHH: state.firmaRRHH,
  firmaRL: state.firmaRL,
});

export default connect(mapStateToProps, mapDispatchToProps)(Recibos);
